export default {"src":"/_next/static/media/n.c6424472.svg","height":43,"width":28,"blurWidth":0,"blurHeight":0};